'use client';

import logger from '@/utils/client-logger';
import { Box } from '@mui/material';
import FaqAccordion from '../../components/FaqAccordion';
import { useTransitionTracker } from '../hooks/useTransitionTracker';
interface FbqPartProps {
  faqData: {
    title: string;
    faq_arr: Array<{
      question: string;
      answer: string;
    }>;
  };
  statement: string;
}

// 替换图标
const replaceIcons = (content: string) => {
  try {
    if (typeof content !== 'string') return content;

    return content
      .replace(/<i class="iconfont icon-shangbiao"><\/i>/g, '®')
      .replace(/<i class="iconfont icon-line-trademarkshangbiao"><\/i>/g, '™');
  } catch (error) {
    logger.error('Failed to replace icons:', error);
    return content;
  }
};

export default function FbqPart({ faqData, statement }: FbqPartProps) {
  const { trackFAQClick } = useTransitionTracker();

  // 处理数据中的图标
  const processedFaqData = {
    title: replaceIcons(faqData.title),
    data_array: faqData.faq_arr.map((item) => ({
      question: replaceIcons(item.question),
      answer: replaceIcons(item.answer),
    })),
  };

  return (
    <div className="w-full">
      <FaqAccordion
        faqData={processedFaqData}
        className="!bg-[#F4F4F4]"
        onFaqClick={trackFAQClick}
      />

      {/* 声明部分 */}
      {statement && (
        <Box className="px-[14px] lg:px-[224px] 2xl:px-[448px] pb-[32px] lg:pb-[50px] 2xl:pb-[72px]">
          <Box className="text-left">
            <Box
              className="text-[12px] leading-[24px] lg:text-[14px] lg:leading-[32px] mx-auto"
              dangerouslySetInnerHTML={{ __html: replaceIcons(statement) }}
            />
          </Box>
        </Box>
      )}
    </div>
  );
}
